import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";
import styled from "styled-components";
import { } from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import arrowRight from "../../assets/images/icon_home/arrow-right.svg";
import wallet from "../../assets/images/icon_home/wallet.svg";
import all from "../../assets/images/icon_home/all.svg";
import card from "../../assets/images/icon_home/card.svg";
import addUser from "../../assets/images/icon_home/add-user.svg";
import transaction from "../../assets/images/icon_home/transaction.svg";
import mutation from "../../assets/images/icon_home/mutation.svg";
import attendance from "../../assets/images/icon_home/attendance.svg";
import invoice from "../../assets/images/icon_home/invoice.svg";
import donasi from "../../assets/images/icon_home/donation.svg";
import jadwal from "../../assets/images/icon_home/schedule.svg";
import kalender from "../../assets/images/icon_home/kalender.svg";
import support from "../../assets/images/icon_home/support.svg";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import info from "../../assets/images/icon_home/info.svg";
import note from "../../assets/images/icon_home/note.svg";
import bsiBurekol from "../../assets/images/icon_home/bsi.svg";

import Calender from "../common/home/Calendar";
import Company from "../../core/models/company";
import { setLoading } from "../../core/feature/config/configSlice";
import {
  Link,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import drop from "../../assets/images/icon_home/drop.svg";
import User from "../../core/models/user";
import Token from "../../core/models/token";
import _, { find } from "lodash";
import Config from "../../config/Config";
import { toast } from "react-toastify";
import Carousel from "react-multi-carousel";
import "./home.scss";
import "react-multi-carousel/lib/styles.css";
import Content from "../common/home/Content";
import { Stats } from "../common/home/Stats";
import { useDispatch } from "react-redux";
import { setBalance } from "../../core/feature/user/balanceSlice";
import { removeToken, setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/balance/balanceSlice";
import { getInfoNews } from "../../core/service/api_info";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Dialog, Transition } from "@headlessui/react";
import * as API from "../../core/service/api.js";
import { } from "../../core/feature/store";
import * as api_balance from "../../core/service/api_balance";
import * as api_info from "../../core/service/api_info";
import { formatCurrency, showSvg } from "../../config/global";
import users from "../../assets/images/icon_home/user.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getAllInvoice } from "../../core/service/api_invoice";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Keyboard, Navigation, Autoplay } from "swiper";
import axios from "axios";
import tagihankosong from "../../assets/images/icon_home/tagihankosong.svg";
import CalendarAcademik from "../common/home/CalenderAcademik";
import * as api_academic from "../../core/service/api_academic";
import { useTranslation } from "react-i18next";
import {
  getBroadcastActive,
  getNotifData,
} from "../../core/service/api_notification";
import "swiper/css/autoplay";
import "rsuite/dist/rsuite.min.css";
import { Button, Tooltip, Whisper } from "rsuite";
import banner from "../../assets/images/icon_stock/banner.png";
import { createPassword, updatePassword } from "../../core/service/api_profile";
import CustomApp from "../../core/models/customApp";
import {
  removeCustomApp,
  setCustomApp,
} from "../../core/feature/company/customAppsSlice";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import { log } from "console";
import { removeLastService } from "../../core/feature/lastService/lastServiceSlice";
import IconApp from "../../core/models/iconApp";
import { setIconApp } from "../../core/feature/company/iconAppSlice";
import { isDarkColor } from "../../config/DarkColorChecker";
import Routes from "../../Routes";
import { logoutIOS, openUrlInSafari } from "../../config/iosBridge";
import * as api_company from "../../core/service/api_company";
moment.locale("en");

const HomeWeb = () => {
  const language: String = useAppSelector((state) => state.language.language);
  const [lang, setLang] = useState(language);
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const company: Company = useAppSelector((state) => state.company.company);
  const iconApp: IconApp = useAppSelector((state) => state.iconApp.iconApp);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [data, setData] = useState<any>([]);
  const [info, setInfo] = useState<any>([]);
  const [berita, setBerita] = useState();
  const [showSupport, setShowSupport] = useState(false);
  const url = Config.BaseUrlDev;
  const location = useLocation();
  const { cid } = useParams();
  const [pathName, setPathName] = useState(
    location.pathname.replaceAll("/", "").toUpperCase()
  );
  const auto = localStorage.getItem("auto_login");
  const [selectedTags, setSelectedTags] = useState(["info"]);
  const [lastPage, setLastPage] = useState(0);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showPopUpPassword, setShowPopUpPassword] = useState(false);
  const { t } = useTranslation();
  const [broadcast, setBroadcast] = useState<any>([]);
  const [typePassword, setTypePassword] = useState("password");
  const [typePassword2, setTypePassword2] = useState("password");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showNews, setShowNews] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [totalPesan, setTotalPesan] = useState(0);
  const [listEvent, setListEvent] = useState<any>([]);
  const [handleSVG, sethandleSvg] = useState<any>({});
  const [menu, setMenu] = useState<any>([]);
  const [getToken, setTokens] = useState(localStorage.getItem("token_redux"));
  const [showPopup, setShowPopup] = useState(false);
  const [getCompanyInital, setCompanyInitial] = useState<any>("");
  const default_menu = [
    {
      menu_name: t("HOME.menu.topup"),
      menu_icon_url: wallet,
      menu_is_show: true,
      menu_path: "/topup",
    },
    {
      menu_name: t("HOME.menu.invoice"),
      menu_icon_url: invoice,
      menu_is_show: true,
      menu_path: "/invoice",
    },
    {
      menu_name: t("HOME.menu.mutation"),
      menu_icon_url: mutation,
      menu_is_show: true,
      menu_path: "/mutation",
    },
    {
      menu_name: t("HOME.menu.transaction"),
      menu_icon_url: transaction,
      menu_is_show: true,
      menu_path: "/transaction-history",
    },
    {
      menu_name: t("HOME.menu.attendance"),
      menu_icon_url: attendance,
      menu_is_show: true,
      menu_path: "/attendance",
    },
    {
      menu_name: t("HOME.menu.digitalCard"),
      menu_icon_url: card,
      menu_is_show: true,
      menu_path: "/digital-card",
    },
    {
      menu_name: t("HOME.menu.account"),
      menu_icon_url: addUser,
      menu_is_show: true,
      menu_path: "/account",
    },
    {
      menu_name: t("HOME.menu.donation"),
      menu_icon_url: donasi,
      menu_is_show: true,
      menu_path: "/donation",
    },
    {
      menu_name: t("HOME.menu.timetable"),
      menu_icon_url: jadwal,
      menu_is_show: true,
      menu_path: "/schedule",
    },
    {
      menu_name: t("HOME.menu.calendarAcademic"),
      menu_icon_url: kalender,
      menu_is_show: true,
      menu_path: "/calendar",
    },
    {
      menu_name: "BSI Burekol",
      menu_icon_url: bsiBurekol,
      menu_is_show: true,
      menu_type: "URL",
      menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
    },
  ];

  const isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      userAgent.includes("safari") &&
      !userAgent.includes("chrome") &&
      !userAgent.includes("android")
    );
  };

  const checkRouteExists = (path: string) => {
    return Routes.some((route: any) => "/" + route.path === path);
  };

  const handleMenuClick = (modifiedMenuPath: any, event: any, item: any) => {
    if (item.menu_type === "PAGE") {
      if (!checkRouteExists(item.menu_path)) {
        event.preventDefault();
        setShowPopup(true);
      }
    }
  };

  const closePopUp = async () => {
    setShowPopup(false);
  };

  const getData = () => {
    dispatch(setLoading(true));
    getAllInvoice(size, page, "invoiceDate", "Desc", "", "")
      .then((res: any) => {
        setData(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        // dispatch(removeUser());
        // dispatch(removeBalance());
        dispatch(setLoading(false));
      });
  };

  const getInformasi = () => {
    dispatch(setLoading(true));
    console.log(`${page} ${lastPage}`, "page ");
    api_info
      .getInfoNews(0, selectedTags, 10)
      .then((res: any) => {
        setInfo(res.data.content);
        dispatch(setLoading(false));
        console.log(res);
        console.log(data);
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  async function getEvent() {
    api_academic
      .getAgenda(
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD")
      )
      .then((res: any) => {
        setListEvent(res.data.content);
      })
      .catch((e: any) => {
        setListEvent([]);
      });
  }

  const getCustomApp = async () => {
    var temp: any = [];
    customApp?.app_menu.map((menu: any, key: number) => {
      if (menu.menu_path === "/calendar") {
        setShowCalendar(menu.menu_is_show);
      }
      if (menu.menu_path === "/invoice") {
        setShowInvoice(menu.menu_is_show);
      }
    });
  };

  const getIconApp = async (customData: any = null) => {
    let result: any = {};

    let tempCustomApp: any = customApp?.app_menu.filter(
      (filter: any) => filter.menu_is_show == true
    );

    if (customApp == undefined) {
      for (let index = 0; index < tempCustomApp.length; index++) {
        console.log(tempCustomApp[index].menu_name);
        await API.getIconApps(
          customData.company_id,
          tempCustomApp[index].menu_icon_url
        ).then((res) => {
          result[tempCustomApp[index].id] = res.data;
        });
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    } else {
      console.log(customApp, `line 286, length ${customApp.app_menu.length}`);
      console.log(tempCustomApp, `line 287, length ${tempCustomApp.length}`);
      for (let index = 0; index < tempCustomApp.length; index++) {
        console.log(tempCustomApp[index].menu_icon_url);
        await API.getIconApps(
          customApp?.company_id,
          tempCustomApp[index].menu_icon_url
        ).then((res) => {
          result[tempCustomApp[index].id] = res.data;
        });
      }
      dispatch(setIconApp(result));
      sethandleSvg(result);
    }
  };

  const getBroadcast = () => {
    getBroadcastActive("ACTIVE", "MOBILE")
      .then((res) => {
        if (res.data.content.length > 0) {
          console.log(res, "broadcast");
          setBroadcast(res.data.content);
          if (JSON.parse(String(localStorage.getItem("broadcast"))) == "0") {
            setShowPopUp(true);
          }
        } else {
          console.log(res, "kosong");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const [supportOpened, setSupportOpened] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [dataNews, setdataNews] = useState<any>([]);
  const env = Config.BaseUrlDev;
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  function sendMessage() {
    let userStorage = JSON.parse(String(localStorage.getItem("user_redux")));
    let companyStorage = JSON.parse(String(localStorage.getItem("company")));
    let url = "";
    let anak = [];
    let phone = "6281326269992";
    let name = String(userStorage.name).split(" ").join("%20");
    if (userStorage.accounts[0].callerIdentities.length > 1) {
      for (
        let x = 0;
        x < userStorage.accounts[0].callerIdentities.length;
        x++
      ) {
        anak[x] = String(userStorage.accounts[0].callerIdentities[x].name)
          .split(" ")
          .join("%20");
      }
      let d =
        "%20dan%20" + anak[userStorage.accounts[0].callerIdentities.length - 1];
      // d = String(d).substr(0, d.length - 3)
      anak[userStorage.accounts[0].callerIdentities.length - 1] = d;
      url =
        "https://wa.me/" +
        phone +
        "?text=Halo,%20saya%20" +
        name +
        "%20orang%20tua%20dari%20";
      url += anak;
    } else if (userStorage.accounts[0].callerIdentities.length == 1) {
      anak[0] = String(userStorage.accounts[0].callerIdentities[0].name)
        .split(" ")
        .join("%20");
      url =
        "https://wa.me/" +
        phone +
        "?text=Halo,%20saya%20" +
        name +
        "%20orang%20tua%20dari%20";
      url += anak;
    } else {
      url = "https://wa.me/" + phone + "?text=Halo,%20saya%20" + name;
    }
    let company = String(companyStorage.name).split(" ").join("%20");
    let pesan = String(supportMessage).split(" ").join("%20");
    url +=
      "%20dari%20" +
      company +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A";
    url += pesan;
    setSupportOpened(false);
    window.open(url, "_blank");
  }

  function openSupport() {
    setShowSupport(true);
  }

  function closeSupport() {
    setShowSupport(false);
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }
  const updatePass = async () => {
    if (newPassword !== newPassword2)
      return toast.warning(
        "Silahkan cek kembali password anda, password baru tidak sama."
      );
    var query = {
      email: user.email,
      password: newPassword2,
      phone: user.phone,
    };
    dispatch(setLoading(true));
    createPassword(query)
      .then((res) => {
        dispatch(setLoading(false));

        console.log(res);
        toast.success("Berhasil");
        setShowPopUpPassword(false);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        setShowPopUpPassword(false);
      });
  };

  function openModal(item: any) {
    // setIsOpen(true);
    navigate("/info-detail/" + item._id, { replace: true });
  }

  const login = async () => {
    var CryptoJS = require("crypto-js");
    var getCredential = localStorage.getItem("credential");

    var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    var data = decryptedData;

    API.login(data)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck()
          .then((resCredential) => {
            var auto = "1";
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              "credential"
            ).toString();
            localStorage.setItem("credential", ciphertext);
            localStorage.setItem("auto_login", auto);
            // var bytes = CryptoJS.AES.decrypt(ciphertext, 'password');
            dispatch(setUser(resCredential.data.user));
            api_balance.getBalance().then((balance) => {
              dispatch(setBalance(balance.data.balance));
              refresh();
              navigate("/home");
            });
          })
          .catch((err: any) => {
            localStorage.setItem("0", "auto_login");

            navigate("/login", { replace: true });
          });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(t("LOGIN.wrongLogin"));
        navigate("/login", { replace: true });
      });
  };

  const getInitial = async (initial: any) => {
    api_company.getCompanyInitial(initial).then((res) => {
      setCompanyInitial(res.data.initial);
    });
  };

  const refresh = async () => {
    getCustomApp();
    getData();
    getInformasi();
    getEvent();
    getBroadcast();
  };

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck()
        .then((resCredential: any) => {
          dispatch(setUser(resCredential.data.user));

          api_balance.getBalance().then((balance) => {
            dispatch(setBalance(balance.data.balance));
            API.getCustomApps(
              resCredential.data.activeCompany.id,
              language.toUpperCase()
            ).then((resCustom: any) => {
              console.log(resCustom.data);
              let tempResCustom = resCustom.data;
              if (!resCredential.data.activeCompany.customApps) {
                tempResCustom.app_display_name =
                  resCredential.data.activeCompany.name;
                tempResCustom.app_icon_url = "psp.svg";
                tempResCustom.app_mobile_background_header_url = "header.svg";
                tempResCustom.app_desktop_background_header_url = "header.svg";
                tempResCustom.app_accent_color = "#0054E6";
                tempResCustom.app_secondary_accent_color = "#0054E6";
              }

              const hasBsiAndNotActive = tempResCustom.app_menu.some(
                ({
                  menu_name,
                  menu_is_show,
                }: {
                  menu_name: string;
                  menu_is_show: boolean;
                }) => menu_name.toLowerCase().includes("bsi") && !menu_is_show
              );

              if (
                resCredential.data.activeCompany.banks.includes("BSI") &&
                hasBsiAndNotActive
              ) {
                // tempResCustom.app_menu.push({
                //   id: "63dfc62c31bd560297c12397",
                //   menu_name: "BSI Burekol",
                //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                //   menu_icon_url: "bsi_burekol.svg",
                //   menu_is_show: true,
                //   menu_type: "URL"
                // });
              }

              dispatch(setCustomApp(tempResCustom));
              getIconApp(resCustom.data);
              navigate("/home", { replace: true });
            });
          });
        })
        .catch((err) => {
          dispatch(removeUser());
          dispatch(removeBalance());
          if (auto === "1") {
            login();
          } else {
            navigate("/login", { replace: true });
          }
        });
    } else {
      if (user == undefined) {
        if (auto === "1") {
          login();
        } else {
          navigate("/login", { replace: true });
        }
      } else {
        API.credentialCheck()
          .then((resCredential: any) => {
            dispatch(setUser(resCredential.data.user));
            if (resCredential.data.firstLogin === true) {
              setShowPopUpPassword(true);
            }
            api_balance
              .getBalance()
              .then((balance) => {
                dispatch(setBalance(balance.data.balance));
                getInitial(resCredential.data.activeCompany.companyCode);
                api_balance
                  .getBalance()
                  .then((res) => {
                    dispatch(setBalance(res.data.balance));
                    API.getCustomApps(
                      resCredential.data.activeCompany.id,
                      language.toUpperCase()
                    ).then((resCustom: any) => {
                      console.log(resCustom.data);
                      let tempResCustom = resCustom.data;
                      if (!resCredential.data.activeCompany.customApps) {
                        tempResCustom.app_display_name =
                          resCredential.data.activeCompany.name;
                        tempResCustom.app_icon_url = "psp.svg";
                        tempResCustom.app_mobile_background_header_url =
                          "header.svg";
                        tempResCustom.app_desktop_background_header_url =
                          "header.svg";
                        tempResCustom.app_accent_color = "#0054E6";
                        tempResCustom.app_secondary_accent_color = "#0054E6";
                      }

                      const hasBsiAndNotActive = tempResCustom.app_menu.some(
                        ({
                          menu_name,
                          menu_is_show,
                        }: {
                          menu_name: string;
                          menu_is_show: boolean;
                        }) =>
                          menu_name.toLowerCase().includes("bsi") &&
                          !menu_is_show
                      );
                      console.log(hasBsiAndNotActive);
                      console.log(
                        resCredential.data.activeCompany.banks.includes("BSI")
                      );
                      if (
                        resCredential.data.activeCompany.banks.includes(
                          "BSI"
                        ) &&
                        hasBsiAndNotActive
                      ) {
                        // tempResCustom.app_menu.push({
                        //   id: "63dfc62c31bd560297c12397",
                        //   menu_name: "BSI Burekol",
                        //   menu_path: "https://bsi-burekol.dev.teknologikartu.com/Home",
                        //   menu_icon_url: "bsi_burekol.svg",
                        //   menu_is_show: true,
                        //   menu_type: "URL"
                        // });
                        console.log("adding BSI Tambahan");
                      }
                      console.log(
                        tempResCustom,
                        `line 603, length ${tempResCustom.app_menu.length}`
                      );
                      dispatch(setCustomApp(tempResCustom));
                      console.log(
                        customApp,
                        `line 605, length ${customApp.app_menu.length}`
                      );
                      if (!iconApp || Object.keys(iconApp).length < 1) {
                        getIconApp(tempResCustom);
                      } else {
                        sethandleSvg(iconApp);
                      }
                      navigate("/home", { replace: true });
                    });
                    refresh();
                    // getInfoNews().then((res) => {
                    //   setdataNews(res.data.content);
                    // });
                  })
                  .catch((err) => {
                    dispatch(removeUser());
                    dispatch(removeBalance());
                    if (auto === "1") {
                      login();
                    } else {
                      navigate("/login", { replace: true });
                    }
                  });
              })
              .catch((err) => {
                dispatch(removeUser());
                dispatch(removeBalance());
                if (auto === "1") {
                  login();
                } else {
                  navigate("/login", { replace: true });
                }
              });
          })
          .catch((err) => {
            dispatch(removeUser());
            dispatch(removeBalance());
            if (auto === "1") {
              login();
            } else {
              navigate("/login", { replace: true });
            }
          });
      }
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    getCustomApp();
    if (!iconApp || Object.keys(iconApp)?.length < 1) {
      getIconApp();
    } else {
      console.log(iconApp);

      sethandleSvg(iconApp);
    }
  }, []);

  useEffect(() => {
    if (iconApp && Object.keys(iconApp)?.length > 0) sethandleSvg(iconApp);
  }, [iconApp]);

  useEffect(() => {
    if (customApp && Object.keys(customApp)?.length > 0) getIconApp();
  }, [customApp]);

  const funTypePassword = async () => {
    if (typePassword == "text") {
      setTypePassword("password");
    } else {
      setTypePassword("text");
    }
  };

  const funTypePassword2 = async () => {
    if (typePassword2 == "text") {
      setTypePassword2("password");
    } else {
      setTypePassword2("text");
    }
  };

  function closeBroadcast() {
    localStorage.setItem("broadcast", "1");
    setShowPopUp(false);
  }

  return (
    <div className="h-full bg-psp-primary font-montserrat pb-20">
      {/* <Carousal /> */}
      <Stats />
      <div className="h-auto flex">
        <div className="mx-none container  h-full flex-row bg-psp-primary flex w-full justify-between ">
          <div
            className={
              showCalendar ? "w-4/6" : "w-full" + "  flex h-auto flex-col px-10"
            }
          >
            <div className="flex flex-row w-full h-auto ">
              <div
                className={
                  showInvoice ? "w-1/2" : "w-full" + " flex h-96 flex-col  mr-4"
                }
              >
                <div className="flex flex-row justify-between item-center">
                  <h1 className="font-montserrat m-0 text-black text-[1.5vw] font-bold">
                    {t("HOME.menu.title")}
                  </h1>
                </div>
                <div className="flex flex-row relative flex-wrap mt-3 w-full">
                  {customApp?.app_menu
                    .filter((flt: any) => flt.menu_is_show == true)
                    .map((item: any, index: any) => {
                      let modifiedMenuPath = item.menu_path;
                      if (item.menu_type === "URL") {
                        const userToken = getToken;
                        modifiedMenuPath = item.menu_path.replace(
                          "token",
                          userToken
                        );

                        if (modifiedMenuPath.includes("companyInitial")) {
                          modifiedMenuPath = modifiedMenuPath.replace(
                            "companyInitial",
                            getCompanyInital
                          );
                        }
                      }

                      return item.menu_type == "PAGE" ? (
                        item.menu_path != "/etc" ? (
                          <Link
                            to={item.menu_path}
                            key={index}
                            className="no-underline w-1/4"
                            onClick={(event) =>
                              handleMenuClick(modifiedMenuPath, event, item)
                            }
                          >
                            <div className="flex flex-col relative items-center ">
                              <div className="w-[54px] h-auto min-h-[54px] items-center justify-center flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300">
                                <LazyLoadImage
                                  hidden={Object.keys(handleSVG).length < 0}
                                  className="  items-center p-2"
                                  effect="blur"
                                  src={showSvg(handleSVG[item.id])}
                                />
                              </div>
                              <p
                                className="font-montserrat  font-medium text-center text-psp-nav mt-2"
                                style={{ fontSize: 10 }}
                              >
                                {item.menu_name} {item.menu_is_show}
                              </p>
                            </div>
                          </Link>
                        ) : (
                          <div
                            className="no-underline w-1/4"
                            onClick={() => openSupport()}
                          >
                            <div className="flex flex-col relative items-center hover:underline hover:cursor-pointer">
                              <div className="w-[54px] h-auto min-h-[54px] cursor-pointer  items-center justify-center flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300">
                                <LazyLoadImage
                                  className="h-auto flex flex-col items-center p-2"
                                  effect="blur"
                                  src={support}
                                />
                              </div>
                              <p
                                className="font-montserrat font-medium text-center text-psp-nav mt-2"
                                style={{ fontSize: 10 }}
                              >
                                {t("HOME.menu.support")}
                              </p>
                            </div>
                          </div>
                        )
                      ) : (
                        <div
                          onClick={() =>
                            localStorage.getItem("device")?.includes("ios")
                              ? openUrlInSafari(modifiedMenuPath)
                              : window.open(modifiedMenuPath)
                          }
                          key={index}
                          className="no-underline w-1/4"
                        >
                          <div className="flex flex-col relative items-center ">
                            <div className="w-[54px] h-auto min-h-[54px]  items-center justify-center flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300">
                              <LazyLoadImage
                                className=" flex flex-col items-center p-2"
                                effect="blur"
                                src={showSvg(handleSVG[item.id])}
                              />
                            </div>
                            <p
                              className="font-montserrat  font-medium text-center text-psp-nav mt-2"
                              style={{ fontSize: 10 }}
                            >
                              {item.menu_name} {item.menu_is_show}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  {/* <div
                    className="no-underline w-1/4"
                    onClick={() => openSupport()}
                  >
                    <div className="flex flex-col relative items-center hover:underline hover:cursor-pointer">
                      <div className="w-[54px] h-auto min-h-[54px] cursor-pointer  items-center justify-center flex flex-col rounded-2xl  bg-white active:bg-black shadow-md shadow-gray-300">
                        <LazyLoadImage
                          className="h-auto flex flex-col items-center p-2"
                          effect="blur"
                          src={support}
                        />
                      </div>
                      <p
                        className="font-montserrat font-medium text-center text-psp-nav mt-2"
                        style={{ fontSize: 10 }}
                      >
                        {t("HOME.menu.support")}
                      </p>
                    </div>
                  </div> */}
                </div>
              </div>

              <div hidden={!showInvoice} className=" w-1/2 flex h-96 flex-col">
                <div className="flex flex-row justify-between item-center">
                  <h1 className="font-montserrat m-0 text-black text-[1.5vw] font-bold">
                    {t("HOME.menu.invoice")}
                  </h1>
                  <div
                    onClick={() => navigate("/invoice")}
                    className="flex flex-row gap-2 items-center cursor-pointer"
                  >
                    <h1 className="text-psp-primary m-0 font-medium text-xs grow whitespace-nowrap cursor-pointer">
                      {t("HOME.viewAll")}
                    </h1>
                    <img src={arrowRight} className="flex-0" />
                  </div>
                </div>
                <div className="mt-3 rounded-2xl overflow-y-auto overflow-x-visible h-80  px-2">
                  {data.length < 1 ? (
                    <div className="flex relative flex-col justify-center items-center   ">
                      <img
                        src={tagihankosong}
                        alt=""
                        className="mx-auto mt-10"
                      ></img>
                      <div className="flex flex-col ">
                        <span className="font-bold text-center text-[1.5vw]">
                          {t("HOME.emptyInvoice")}
                        </span>
                        <span className="text-[1vw] text-center font-montserrat">
                          {t("HOME.titleEmptyInvoice")}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className=" relative flex flex-col">
                      {data.map((item: any, index: any) => {
                        if (index < 5) {
                          return (
                            <div
                              key={index}
                              className="rounded-2xl border border-black bg-white py-2 px-2  w-full my-2 "
                            >
                              <div className="flex relative items-center h-full flex-row w-full justify-between">
                                <div className="flex flex-row relative w-1/2 justify-start items-center">
                                  <img
                                    src={note}
                                    alt=""
                                    className="w-6 h-6 relative"
                                  />
                                  <Whisper
                                    className="font-montserrat relative flex flex-wrap bg-white font-medium text-left text-psp-nav text-[10px] ml-2 mt-1"
                                    followCursor
                                    speaker={
                                      <Tooltip className="bg-pink-600">
                                        {item.title}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="font-montserrat flex-wrap cursor-pointer font-medium text-left text-psp-nav text-[10px] mx-2 mt-1">
                                      {item.title.length > 35
                                        ? `${item.title.substring(0, 35)}...`
                                        : item.title}
                                    </span>
                                  </Whisper>
                                </div>
                                <div className="flex flex-row relative w-1/2 h-full justify-end items-baseline ">
                                  <div className="font-montserrat relative flex flex-wrap bg-white font-medium text-left text-psp-nav text-[10px] ml-2 mt-1">
                                    <span className="font-montserrat flex-wrap text-right font-semibold text-[0.8vw] mx-2">
                                      {formatCurrency(item.amount)}
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => navigate("/invoice")}
                                    style={
                                      customApp?.app_accent_color
                                        ? {
                                          backgroundColor:
                                            customApp?.app_accent_color,
                                        }
                                        : {
                                          backgroundColor:
                                            "rgb(59 130 246 / var(--tw-bg-opacity))",
                                        }
                                    }
                                    className={`bg-blue-500 h-[3.5vh] w-auto py-1 px-2 rounded-lg font-montserrat text-sm font-normal ${isDarkColor(customApp?.app_accent_color)
                                        ? "text-white"
                                        : "text-black"
                                      }`}
                                  >
                                    {t("HOME.pay")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className=" w-full flex h-96 mb-20  flex-col">
              <div className="flex flex-row justify-between item-center">
                <h1 className="font-montserrat m-0 text-black text-[1.5vw] font-bold">
                  {t("HOME.info")}
                </h1>
                <div
                  onClick={() => navigate("/info")}
                  className="flex flex-row gap-2 items-center cursor-pointer"
                >
                  <h1 className="text-psp-primary m-0 font-medium text-xs grow whitespace-nowrap cursor-pointer">
                    {t("HOME.viewAll")}
                  </h1>
                  <img src={arrowRight} className="flex-0" />
                </div>
              </div>
              <div className="mb-8  mt-3">
                <div className="flex overflow-x-auto h-auto">
                  <div className="flex flex-nowrap w-full gap-3 h-full ">
                    <Swiper
                      onSlideChange={(e) => { }}
                      onSwiper={(swiper) => { }}
                      effect={"fade"}
                      grabCursor={true}
                      centeredSlides={false}
                      pagination={true}
                      loop={false}
                      keyboard={{
                        enabled: true,
                      }}
                      centeredSlidesBounds={false}
                      slidesPerView={2}
                      navigation={{
                        prevEl: ".swiper-button-prev",
                        nextEl: ".swiper-button-next",
                      }}
                      onScroll={(e) => { }}
                      coverflowEffect={{
                        rotate: 0,
                        stretch: 50,
                        depth: 100,
                        modifier: 2.5,
                        slideShadows: false,
                      }}
                      modules={[Navigation, Keyboard]}
                      className="w-full h-auto mb-10 sm:mb-20 relative items-center justify-center cursor-pointer"
                    >
                      {info.map((item: any, index: any) => {
                        if (item.isHeadline === true) {
                          return (
                            <SwiperSlide key={index}>
                              <div className="p-2">
                                <div
                                  onClick={() => openModal(item)}
                                  className="mb-5 w-full h-80 shadow-md rounded-2xl relative bg-white"
                                >
                                  <div className="h-full">
                                    {item.imageOpt.length < 1 && item.image && (
                                      <img
                                        src={getImgContent(item.image)}
                                        alt=""
                                        className="rounded-t-2xl h-4/5  relative w-full object-cover"
                                      />
                                    )}
                                    {item.imageOpt.length > 0 && item.image && (
                                      <img
                                        src={getImgContent(item.image)}
                                        alt=""
                                        className="rounded-t-2xl h-4/5  relative w-full object-cover"
                                      />
                                    )}
                                    {item.imageOpt.length > 0 &&
                                      !item.image && (
                                        <img
                                          src={getImgContent(item.imageOpt[0])}
                                          alt=""
                                          className="rounded-t-2xl h-4/5  relative w-full object-cover"
                                        />
                                      )}
                                    {item.imageOpt.length == 0 &&
                                      item.image == "" &&
                                      item.videoUrl == "" && (
                                        <img
                                          className="rounded-t-2xl h-4/5  relative w-full object-cover"
                                          alt=""
                                          src={banner}
                                        />
                                      )}
                                    {item.imageOpt.length == 0 &&
                                      !item.image &&
                                      item.videoUrl && (
                                        <img
                                          src={`https://img.youtube.com/vi/${getYtCode(
                                            item.videoUrl
                                          )}/sddefault.jpg`}
                                          alt=""
                                          className="rounded-t-2xl h-4/5  relative w-full object-cover"
                                        />
                                      )}
                                    <div className="relative flex flex-col px-2 py-2  ">
                                      <Whisper
                                        className="font-montserrat relative flex flex-wrap bg-white font-medium text-left text-psp-nav text-[10px] ml-2 mt-1"
                                        followCursor
                                        speaker={
                                          <Tooltip className="bg-pink-600">
                                            {item.title}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="text-sm font-bold text-black bottom-46 text-left m-0">
                                          {item.title.length > 35
                                            ? `${item.title.substring(
                                              0,
                                              35
                                            )}...`
                                            : item.title}
                                        </span>
                                      </Whisper>
                                      <p className="text-xs font-medium text-psp-gray text-left m-0">
                                        {moment(item.updateTime).format(
                                          "DD MMMM YYYY"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                          );
                        }
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            hidden={!showCalendar}
            className=" w-auto flex max-w-sm h-auto  right-0"
          >
            <CalendarAcademik
              year={moment().format("YYYY")}
              start={moment().startOf("month").format("YYYY-MM-DD")}
              end={moment().endOf("month").format("YYYY-MM-DD")}
              month={moment().format("MMM")}
              list={listEvent}
            />
          </div>
        </div>
      </div>
      <Transition
        show={showSupport}
        enter="transition-opacity duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
            <div className="relative w-96 h-auto my-6 mx-auto max-w-6xl">
              <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none py-3 px-3">
                <span className="font-bold">Customer Service</span>
                <div className="mt-2">
                  <textarea
                    onChange={(e) => setSupportMessage(e.target.value)}
                    placeholder="Masukkan Pesan Anda"
                    className="w-full py-1 px-2 rounded-lg border"
                  ></textarea>
                </div>
                <div className="mt-4 flex flex-row justify-evenly">
                  <button
                    type="button"
                    style={{
                      backgroundColor: customApp?.app_secondary_accent_color,
                    }}
                    className={`w-full h-10 ml-1 rounded-md ${isDarkColor(customApp.app_secondary_accent_color)
                        ? "text-white"
                        : "text-black"
                      }`}
                    onClick={closeSupport}
                  >
                    {t("DIGITALCARD.cancel")}
                  </button>
                  <button
                    type="button"
                    style={{ backgroundColor: customApp?.app_accent_color }}
                    className={`w-full h-10 ml-1 rounded-md ${isDarkColor(customApp.app_accent_color)
                        ? "text-white"
                        : "text-black"
                      }`}
                    onClick={sendMessage}
                  >
                    {t("HOME.send")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>

      <Transition
        show={showPopUp}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
            <div className="relative w-full min-w-[400px] h-auto my-6 mx-auto max-w-3xl max-h-[790px] bg-white rounded-xl ">
              <div className="w-full p-3 text-xl shadow-md">
                {broadcast.map((item: any, i: any) => {
                  if (i === 0) return <span>{item.title}</span>;
                })}
              </div>
              <div className="p-4 pb-5 bg-psp-primary shadow-md">
                <div className="bg-white rounded-xl shadow">
                  {broadcast.map((item: any, index: any) => {
                    if (index === 0) {
                      if (item.broadcastType === "IMAGE")
                        return (
                          <div key={index} className="w-auto h-auto pb-2">
                            <Swiper
                              autoplay={true}
                              pagination={{ clickable: true, type: "fraction" }}
                              navigation
                              slidesPerView={1}
                              modules={[Pagination, Navigation, Autoplay]}
                            >
                              {item.imagesFirebase.map((a: any, i: any) => {
                                return (
                                  <SwiperSlide key={i}>
                                    <img
                                      src={a}
                                      alt=""
                                      className="max-h-[400px] rounded-xl flex mx-auto object-fill"
                                    ></img>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                            </div>
                          </div>
                        );
                      if (item.broadcastType === "TEXT")
                        return (
                          <div key={index} className="w-full h-auto py-1">
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <div className="mt-4">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.message,
                                  }}
                                ></span>
                              </div>
                            </div>
                          </div>
                        );
                    }
                  })}
                </div>
              </div>
              <div className="relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
                <div className="flex flex-row justify-center my-3">
                  <button
                    type="button"
                    className="w-40 h-10 rounded-xl text-white bg-psp-btn-red flex flex-row"
                    onClick={closeBroadcast}
                  >
                    <span className="py-2.5 px-3">
                      <image>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.1971 6.79639L6.80273 10.1907"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.1979 10.1928L6.80078 6.79489"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.5702 1.94806H5.4297C3.28983 1.94806 1.94824 3.46318 1.94824 5.60731V11.393C1.94824 13.5371 3.28345 15.0522 5.4297 15.0522H11.5695C13.7165 15.0522 15.0524 13.5371 15.0524 11.393V5.60731C15.0524 3.46318 13.7165 1.94806 11.5702 1.94806Z"
                            stroke="#F4F4F4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </image>
                    </span>
                    <span className="font-bold mt-2 ml-3">
                      {t("LOGIN.close")}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>

      <Transition
        show={showPopUpPassword}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat">
            <div className="relative w-1/2 px-5 py-5 rounded-xl  h-auto my-6 mx-auto  bg-psp-primary">
              <div className="flex w-full flex-col relative">
                <h1 className="my-2 text-2xl">{t("PROFILE.changePassword")}</h1>
              </div>
              <div className="w-full ">
                <form className="pt-2">
                  <label className="text-lg">{t("PROFILE.newPassword")}</label>
                  <br />
                  <div className="flex flex-row">
                    <input
                      className="py-3 px-3 w-full border rounded-lg"
                      type={typePassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <img
                      src={typePassword === "text" ? eye : eyeclose}
                      className="cursor-pointer w-8 absolute right-16 mt-2.5"
                      onClick={() => funTypePassword()}
                    />
                  </div>
                </form>
                <form className="pt-2">
                  <label className="text-lg">{t("PROFILE.rePassword")}</label>
                  <br />
                  <div className="flex flex-row">
                    <input
                      className="py-3 px-3 w-full border rounded-lg"
                      value={newPassword2}
                      type={typePassword2}
                      onChange={(e) => setNewPassword2(e.target.value)}
                    />
                    <img
                      src={typePassword2 === "text" ? eye : eyeclose}
                      className="cursor-pointer w-8 absolute right-16 mt-2.5"
                      onClick={() => funTypePassword2()}
                    />
                  </div>
                </form>
                <button
                  onClick={() => updatePass()}
                  className="w-full py-3 mt-4 rounded-xl text-white bg-psp-btn-primary hover:bg-blue-800"
                >
                  {t("DIGITALCARD.save")}
                </button>
                <button
                  onClick={() => setShowPopUpPassword(false)}
                  className="w-full py-3 mt-3 rounded-xl text-white bg-psp-btn-red hover:bg-rose-700"
                >
                  {t("DIGITALCARD.cancel")}
                </button>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>
      <Transition
        show={showPopup}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
          <div className="relative w-96 h-auto my-6 mx-auto max-w-6xl">
            <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none py-3 px-3">
              <span className="font-bold">{t("PROFILE.confirm")}</span>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {t("HOME.undefinedMenu")}
                </p>
              </div>
              <div className="mt-4 flex gap-2">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                  onClick={() => closePopUp()}
                >
                  {t("HOME.close")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        {/* <div className="relative z-10">
          <div className="fixed inset-0 overflow-y-auto font-montserrat">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              
                <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <span className="text-lg font-medium leading-6 text-gray-900">
                    {t("PROFILE.confirm")}
                  </span>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("HOME.undefinedMenu")}
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => closePopUp()}
                    >
                      {t("HOME.close")}
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div> */}
      </Transition>
    </div>
  );
};

export default HomeWeb;
